import { unregister } from '../registerServiceWorker';

export function showMessage(resp, messageType) {
    return { type: 'SHOW_MESSAGE', payload: resp, messageType: messageType }
}

export function showError() {
    return { type: 'SHOW_ERROR'}
}

export function clearMessage() {
    return { type: 'CLEAR_MESSAGE' }
}

export function closePopup() {
    return { type: 'CLOSE_POPUP' }
}

export function showPopup(name, info = null, flag = true) {
    return { type: 'SHOW_POPUP', popup: name, popupInfo: info, popupFlag: flag }
}

export function showProgress(payload) {
    return { type: 'SHOW_PROGRESS', payload }
}

export function resetProgress() {
    return { type: 'RESET_PROGRESS' }
}

export function applyFilter(searchTerm, reducer) {
    switch (reducer) {
    case "presentations":
        return {
            type: 'APPLY_FILTER_PRESENTATIONS', payload: searchTerm,
        }
    case "databases": 
        return {
            type: 'APPLY_FILTER_DATABASES', payload: searchTerm,
        }
    case "admin":
        return {
            type: 'APPLY_FILTER_USERS', payload: searchTerm,
        }
    default: 
        return {
            type: 'SHOW_MESSAGE', payload: "Current Page Does not Accept Search Terms"
        }
    }
}

export function applyTagsFilter(tagsList) {
    return { type: 'APPLY_FILTER_PRESENTATIONS_TAGS', payload: tagsList }
}

export function loadingStart(message) {
    return { type: 'LOADING_START', payload: message }
}

export function loadingEnd() {
    return { type: 'LOADING_END' }
}

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export function refreshCacheAndReload() {
    return function (dispatch) {
        console.log('Clearing cache and hard reloading...')
        dispatch(showPopup("loadingPopup", "New version detected. BI Cloud will now be refreshed."));
        sleep(2000).then(() => {
            // Unregister the service worker (To clear the cache) and then redirect to the homepage
            unregister();
            dispatch(closePopup());
            if ('caches' in window) {
                caches.keys().then((names) => {
                    // Delete all the cache files 
                    names.forEach(name => {
                        caches.delete(name);
                    });
                });
            }
            //window.location.reload(true);
            window.location = window.location.origin;
        });
           //  window.location = "/?timestamp=" + (new Date()).getTime();

    }
}